import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};
const routes = [
  {
    path: "/",
    redirect: "/VehicleManagement/VehicleStatus",
    component: (resolve) => require(["../layout/index.vue"], resolve),
    meta: {
      title: "home",
    },
    children: [
      {
        path: '/BackgroundSettings/DictionaryManaged/DictionaryItem',
        name: 'DictionaryItem',
        navShow: false,
        component: resolve => require(['../views/BackgroundSettings/DictionaryManaged/DictionaryItem/DictionaryItem.vue'], resolve),
        meta: {
          title: "DictionaryItem",
        },
      },
      {
        path: '/GovernmentRegulation/EnforcementNotes/NoteDetail',
        name: 'NoteDetail',
        navShow: false,
        component: resolve => require(['../views/GovernmentRegulation/EnforcementNotes/NoteDetail/NoteDetail.vue'], resolve),
        meta: {
          title: "NoteDetail",
        },
      },
      {
        path: "/VehicleManagement",
        name: "VehicleManagement",
        redirect: "/VehicleManagement/VehicleFiles",
        icon: "caricon",
        navShow: false,
        component: (resolve) => require(["../layout/transfer.vue"], resolve),
        meta: {
          title: "VehicleManagement"
        },
        children: [{
          path: "/VehicleManagement/VehicleFiles",
          name: "VehicleFiles",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/VehicleManagement/VehicleFiles/VehicleFiles.vue",
            ], resolve),
          meta: {
            title: "VehicleFiles",
            affix: true,
            keepAlive: true
          },
        }, {
          path: "/VehicleManagement/VehicleAnnualReview",
          name: "VehicleAnnualReview",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/VehicleManagement/VehicleAnnualReview/VehicleAnnualReview.vue",
            ], resolve),
          meta: {
            title: "VehicleAnnualReview",
            keepAlive: true
          },
        }, {
          path: "/VehicleManagement/VehicleStatus",
          name: "VehicleStatus",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/VehicleManagement/VehicleStatus/VehicleStatus.vue",
            ], resolve),
          meta: {
            title: "VehicleStatus",
            keepAlive: true
          },
        },
        {
          path: "/VehicleManagement/VehicleDistribution",
          name: "VehicleDistribution",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/VehicleManagement/VehicleDistribution/VehicleDistribution.vue",
            ], resolve),
          meta: {
            title: "VehicleDistribution",
            keepAlive: true
          },
        },
        {
          path: "/VehicleManagement/VehicleTrajectory",
          name: "VehicleTrajectory",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/VehicleManagement/VehicleTrajectory/VehicleTrajectory.vue",
            ], resolve),
          meta: {
            title: "VehicleTrajectory",
            keepAlive: true
          },
        },
        {
          path: "/VehicleManagement/MaintainManagement",
          name: "MaintainManagement",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/VehicleManagement/MaintainManagement/MaintainManagement.vue",
            ], resolve),
          meta: {
            title: "MaintainManagement",
            keepAlive: true
          },
        },
        {
          path: "/VehicleManagement/MaintenanceProgram",
          name: "MaintenanceProgram",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/VehicleManagement/MaintenanceProgram/MaintenanceProgram.vue",
            ], resolve),
          meta: {
            title: "MaintenanceProgram",
            keepAlive: true
          },
        },
        {
          path: "/VehicleManagement/MaintenanceManagement",
          name: "MaintenanceManagement",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/VehicleManagement/MaintenanceManagement/MaintenanceManagement.vue",
            ], resolve),
          meta: {
            title: "MaintenanceManagement",
            keepAlive: true
          },
        },
        {
          path: "/VehicleManagement/InsureFile",
          name: "InsureFile",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/VehicleManagement/InsureFile/InsureFile.vue",
            ], resolve),
          meta: {
            title: "InsureFile",
            keepAlive: true
          },
        },
        ],
      },
      {
        path: "/DriverManagement",
        name: "DriverManagement",
        icon: "driveicon",
        navShow: false,
        component: (resolve) => require(["../layout/transfer.vue"], resolve),
        meta: {
          title: "DriverManagement"
        },
        children: [
          {
            path: "/DriverManagement/DriverFile",
            name: "DriverFile",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/DriverFile/DriverFile.vue",
              ], resolve),
            meta: {
              title: "DriverFile",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/DriverAnnualReview",
            name: "DriverAnnualReview",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/DriverAnnualReview/DriverAnnualReview.vue",
              ], resolve),
            meta: {
              title: "DriverAnnualReview",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/DriverStatus",
            name: "DriverStatus",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/DriverStatus/DriverStatus.vue",
              ], resolve),
            meta: {
              title: "DriverStatus",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/KeyFile",
            name: "KeyFile",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/KeyFile/KeyFile.vue",
              ], resolve),
            meta: {
              title: "KeyFile",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/DriverFingerprintFile",
            name: "DriverFingerprintFile",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/DriverFingerprintFile/DriverFingerprintFile.vue",
              ], resolve),
            meta: {
              title: "DriverFingerprintFile",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/NewDriverFingerprintFile",
            name: "NewDriverFingerprintFile",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/NewDriverFingerprintFile/NewDriverFingerprintFile.vue",
              ], resolve),
            meta: {
              title: "NewDriverFingerprintFile",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/DriverFaceFile",
            name: "DriverFaceFile",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/DriverFaceFile/DriverFaceFile.vue",
              ], resolve),
            meta: {
              title: "DriverFaceFile",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/FingerprintLibraryFile",
            name: "FingerprintLibraryFile",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/FingerprintLibraryFile/FingerprintLibraryFile.vue",
              ], resolve),
            meta: {
              title: "DriverTeam",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/AuthorizationManagement",
            name: "AuthorizationManagement",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/AuthorizationManagement/AuthorizationManagement.vue",
              ], resolve),
            meta: {
              title: "AuthorizationManagement",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/DriverAuthorizationManagement",
            name: "DriverAuthorizationManagement",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/DriverAuthorizationManagement/DriverAuthorizationManagement.vue",
              ], resolve),
            meta: {
              title: "DriverAuthorizationManagement",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/FingerprintAuthorization",
            name: "FingerprintAuthorization",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/FingerprintAuthorization/FingerprintAuthorization.vue",
              ], resolve),
            meta: {
              title: "FingerprintAuthorization",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/ICEmpower",
            name: "ICEmpower",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/ICEmpower/ICEmpower.vue",
              ], resolve),
            meta: {
              title: "ICEmpower",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/FaceAuthorize",
            name: "FaceAuthorize",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/FaceAuthorize/FaceAuthorize.vue",
              ], resolve),
            meta: {
              title: "FaceAuthorize",
              keepAlive: true
            },
          },
          {
            path: "/DriverManagement/DriverTrain",
            name: "DriverTrain",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/DriverManagement/DriverTrain/DriverTrain.vue",
              ], resolve),
            meta: {
              title: "DriverTrain",
              keepAlive: true
            },
          },
        ],
      },
      {
        path: "/BatteryManagement",
        name: "BatteryManagement",
        redirect: "/BatteryManagement/BatteryFile",
        icon: "batteryicon",
        navShow: false,
        component: (resolve) => require(["../layout/transfer.vue"], resolve),
        meta: {
          title: "BatteryManagement"
        },
        children: [
          {
            path: "/BatteryManagement/BatteryFile",
            name: "BatteryFile",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BatteryManagement/BatteryFile/BatteryFile.vue",
              ], resolve),
            meta: {
              title: "BatteryFile",
              keepAlive: true
            },
          },
          {
            path: "/BatteryManagement/BatteryStatus",
            name: "BatteryStatus",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BatteryManagement/BatteryStatus/BatteryStatus.vue",
              ], resolve),
            meta: {
              title: "BatteryStatus",
              keepAlive: true
            },
          },
        ],
      },
      {
        path: "/SafeManagement",
        name: "SafeManagement",
        redirect: "/SafeManagement/FaultManagement",
        icon: "safeicon",
        navShow: false,
        component: (resolve) => require(["../layout/transfer.vue"], resolve),
        meta: {
          title: "SafeManagement"
        },
        children: [
          {
            path: "/SafeManagement/FaultManagement",
            name: "FaultManagement",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/SafeManagement/FaultManagement/FaultManagement.vue",
              ], resolve),
            meta: {
              title: "FaultManagement",
              keepAlive: true
            },
          },
          {
            path: "/SafeManagement/ViolationControl",
            name: "ViolationControl",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/SafeManagement/ViolationControl/ViolationControl.vue",
              ], resolve),
            meta: {
              title: "ViolationControl",
              keepAlive: true
            },
          },
          {
            path: "/SafeManagement/EquipmentControl",
            name: "EquipmentControl",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/SafeManagement/EquipmentControl/EquipmentControl.vue",
              ], resolve),
            meta: {
              title: "EquipmentControl",
              keepAlive: true
            },
          },
          {
            path: "/SafeManagement/ElectricFence",
            name: "ElectricFence",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/SafeManagement/ElectricFence/ElectricFence.vue",
              ], resolve),
            meta: {
              title: "ElectricFence",
              keepAlive: true
            },
          },
          {
            path: "/SafeManagement/CloudFence",
            name: "CloudFence",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/SafeManagement/CloudFence/CloudFence.vue",
              ], resolve),
            meta: {
              title: "CloudFence",
              keepAlive: true
            },
          },
          {
            path: "/SafeManagement/CarCheck",
            name: "CarCheck",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/SafeManagement/CarCheck/CarCheck.vue",
              ], resolve),
            meta: {
              title: "CarCheck",
              keepAlive: true
            },
          },
        ],
      },
      {
        path: "/DataAnalysis",
        name: "DataAnalysis",
        redirect: "/DataAnalysis/Comprehensive",
        icon: "analysisicon",
        navShow: false,
        component: (resolve) => require(["../layout/transfer.vue"], resolve),
        meta: {
          title: "DataAnalysis"
        },
        children: [{
          path: "/DataAnalysis/VehicleAnalysis",
          name: "VehicleAnalysis",
          navShow: false,
          component: (resolve) =>
            require([
              "../layout/transfer.vue",
            ], resolve),
          meta: {
            title: "VehicleAnalysis"
          },
          children: [
            {
              path: "/DataAnalysis/VehicleAnalysis/Comprehensive",
              name: "Comprehensive",
              navShow: false,
              component: (resolve) =>
                require([
                  "../views/DataAnalysis/VehicleAnalysis/Comprehensive/Comprehensive.vue",
                ], resolve),
              meta: {
                title: "VehicleEfficiencySummary",
                keepAlive: true
              },
            },
            {
              path: '/DataAnalysis/VehicleAnalysis/Efficiency',
              name: 'Efficiency',
              navShow: false,
              component: resolve => require(['../views/DataAnalysis/VehicleAnalysis/Efficiency/Efficiency.vue'], resolve),
              meta: {
                title: "Efficiency",
                keepAlive: true
              },
            },
            {
              path: '/DataAnalysis/VehicleAnalysis/Duration',
              name: 'Duration',
              navShow: false,
              component: resolve => require(['../views/DataAnalysis/VehicleAnalysis/Duration/Duration.vue'], resolve),
              meta: {
                title: "Duration",
                keepAlive: true
              },
            },
            {
              path: '/DataAnalysis/VehicleAnalysis/Fault',
              name: 'Fault',
              navShow: false,
              component: resolve => require(['../views/DataAnalysis/VehicleAnalysis/Fault/Fault.vue'], resolve),
              meta: {
                title: "Fault",
                keepAlive: true
              },
            },
            {
              path: "/DataAnalysis/VehicleAnalysis/VehicleOrgReport",
              name: "VehicleOrgReport",
              navShow: false,
              component: (resolve) =>
                require([
                  "../views/DataAnalysis/VehicleAnalysis/VehicleOrgReport/VehicleOrgReport.vue",
                ], resolve),
              meta: {
                title: "VehicleOrgReport",
                keepAlive: true
              },
            },
          ]
        },
        {
          path: "/DataAnalysis/DriverAnalysis",
          name: "DriverAnalysis",
          navShow: false,
          component: (resolve) =>
            require([
              "../layout/transfer.vue",
            ], resolve),
          meta: {
            title: "DriverAnalysis"
          },
          children: [
            {
              path: '/DataAnalysis/DriverAnalysis/DriverComprehensive',
              name: 'DriverComprehensive',
              navShow: false,
              component: resolve => require(['../views/DataAnalysis/DriverAnalysis/DriverComprehensive/DriverComprehensive.vue'], resolve),
              meta: {
                title: "DriverComprehensive",
                keepAlive: true
              },
            },
            {
              path: '/DataAnalysis/DriverAnalysis/DriverEfficiency',
              name: 'DriverEfficiency',
              navShow: false,
              component: resolve => require(['../views/DataAnalysis/DriverAnalysis/DriverEfficiency/DriverEfficiency.vue'], resolve),
              meta: {
                title: "DriverEfficiency",
                keepAlive: true
              },
            },
            {
              path: '/DataAnalysis/DriverAnalysis/DriverDuration',
              name: 'DriverDuration',
              navShow: false,
              component: resolve => require(['../views/DataAnalysis/DriverAnalysis/DriverDuration/DriverDuration.vue'], resolve),
              meta: {
                title: "DriverDuration",
                keepAlive: true
              },
            },
            {
              path: '/DataAnalysis/DriverAnalysis/DriverViolation',
              name: 'DriverViolation',
              navShow: false,
              component: resolve => require(['../views/DataAnalysis/DriverAnalysis/DriverViolation/DriverViolation.vue'], resolve),
              meta: {
                title: "DriverViolation",
                keepAlive: true
              },
            },
            {
              path: "/DataAnalysis/DriverAnalysis/DriverOrgReport",
              name: "DriverOrgReport",
              navShow: false,
              component: (resolve) =>
                require([
                  "../views/DataAnalysis/DriverAnalysis/DriverOrgReport/DriverOrgReport.vue",
                ], resolve),
              meta: {
                title: "DriverOrgReport",
                keepAlive: true
              },
            },
          ]
        },
        {
          path: "/DataAnalysis/BatteryAnalysis",
          name: "BatteryAnalysis",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/DataAnalysis/BatteryAnalysis/BatteryAnalysis.vue",
            ], resolve),
          meta: {
            title: "BatteryAnalysis",
            keepAlive: true
          },
        },
        {
          path: "/DataAnalysis/MaintenanceAnalysis",
          name: "MaintenanceAnalysis",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/DataAnalysis/MaintenanceAnalysis/MaintenanceAnalysis.vue",
            ], resolve),
          meta: {
            title: "MaintenanceAnalysis",
            keepAlive: true
          },
        },
        {
          path: "/DataAnalysis/MaintenanceItemAnalysis",
          name: "MaintenanceItemAnalysis",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/DataAnalysis/MaintenanceItemAnalysis/MaintenanceItemAnalysis.vue",
            ], resolve),
          meta: {
            title: "MaintenanceItemAnalysis",
            keepAlive: true
          },
        },
        ],
      },
      {
        path: "/AccounManagement",
        name: "AccounManagement",
        redirect: "/AccounManagement/ContractManagement",
        icon: "accounicon",
        navShow: false,
        component: (resolve) => require(["../layout/transfer.vue"], resolve),
        meta: {
          title: "AccounManagement"
        },
        children: [{
          path: "/AccounManagement/ContractManagement",
          name: "ContractManagement",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/AccounManagement/ContractManagement/ContractManagement.vue",
            ], resolve),
          meta: {
            title: "ContractManagement",
            keepAlive: true
          },
        },
        ],
      },
      {
        path: "/PlatformSettings",
        name: "PlatformSettings",
        navShow: false,
        redirect: "/PlatformSettings/userManagement",
        icon: "platicon",
        component: (resolve) => require(["../layout/transfer.vue"], resolve),
        meta: {
          title: "PlatformSettings"
        },
        children: [{
          path: "/PlatformSettings/userManagement",
          name: "userManagement",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/PlatformSettings/userManagement/userManagement.vue",
            ], resolve),
          meta: {
            title: "userManagement",
            keepAlive: true
          },
        },
        {
          path: "/PlatformSettings/roleManagement",
          name: "roleManagement",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/PlatformSettings/roleManagement/roleManagement.vue",
            ], resolve),
          meta: {
            title: "roleManagement",
            keepAlive: true
          },
        },
        {
          path: "/PlatformSettings/organizaManagement",
          name: "organizaManagement",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/PlatformSettings/organizaManagement/organizaManagement.vue",
            ], resolve),
          meta: {
            title: "organizaManagement",
            keepAlive: true
          },
        },
        {
          path: "/PlatformSettings/dictionaryManagement",
          name: "dictionaryManagement",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/PlatformSettings/dictionaryManagement/dictionaryManagement.vue",
            ], resolve),
          meta: {
            title: "dictionaryManagement",
            keepAlive: true
          },
        },
        {
          path: "/PlatformSettings/checkManagement",
          name: "checkManagement",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/PlatformSettings/checkManagement/checkManagement.vue",
            ], resolve),
          meta: {
            title: "checkManagement",
            keepAlive: true
          },
        },
        {
          path: "/PlatformSettings/ReportPush",
          name: "ReportPush",
          navShow: false,
          component: (resolve) =>
            require([
              "../views/PlatformSettings/ReportPush/ReportPush.vue",
            ], resolve),
          meta: { title: "ReportPush", keepAlive: true },
        },
        ],
      },
      {
        path: "/BackgroundSettings",
        name: "BackgroundSettings",
        redirect: "/BackgroundSettings/TerminalCommand",
        icon: "backgroundicon",
        navShow: false,
        component: (resolve) => require(["../layout/transfer.vue"], resolve),
        meta: {
          title: "BackgroundSettings"
        },
        children: [
          {
            path: "/BackgroundSettings/TerminalCommand",
            name: "TerminalCommand",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BackgroundSettings/TerminalCommand/TerminalCommand.vue",
              ], resolve),
            meta: {
              title: "TerminalCommand",
              keepAlive: true
            },
          },
          {
            path: "/BackgroundSettings/CompanyManagement",
            name: "CompanyManagement",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BackgroundSettings/CompanyManagement/CompanyManagement.vue",
              ], resolve),
            meta: {
              title: "CompanyManagement",
              keepAlive: true
            },
          },
          {
            path: "/BackgroundSettings/JurisdictionalManagement",
            name: "JurisdictionalManagement",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BackgroundSettings/JurisdictionalManagement/JurisdictionalManagement.vue",
              ], resolve),
            meta: {
              title: "JurisdictionalManagement",
              keepAlive: true
            },
          },
          {
            path: "/BackgroundSettings/OTAManagement",
            name: "OTAManagement",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BackgroundSettings/OTAManagement/OTAManagement.vue",
              ], resolve),
            meta: {
              title: "OTAManagement",
              keepAlive: true
            },
          },
          {
            path: "/BackgroundSettings/DictionaryManaged",
            name: "DictionaryManaged",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BackgroundSettings/DictionaryManaged/DictionaryManaged.vue",
              ], resolve),
            meta: {
              title: "DictionaryManaged",
              keepAlive: true
            },
          },
          {
            path: "/BackgroundSettings/TerminalFile",
            name: "TerminalFile",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BackgroundSettings/TerminalFile/TerminalFile.vue",
              ], resolve),
            meta: {
              title: "TerminalFile",
              keepAlive: true
            },
          },
          {
            path: "/BackgroundSettings/SIMFile",
            name: "TerminalFile",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BackgroundSettings/SIMFile/SIMFile.vue",
              ], resolve),
            meta: {
              title: "SIMFile",
              keepAlive: true
            },
          },
          {
            path: "/BackgroundSettings/ExternalEqu",
            name: "ExternalEqu",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BackgroundSettings/ExternalEqu/ExternalEqu.vue",
              ], resolve),
            meta: {
              title: "ExternalEqu",
              keepAlive: true
            },
          },
          {
            path: "/BackgroundSettings/MenuManagement",
            name: "MenuManagement",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BackgroundSettings/MenuManagement/MenuManagement.vue",
              ], resolve),
            meta: {
              title: "MenuManagement",
              keepAlive: true
            },
          },
          {
            path: "/BackgroundSettings/EquipmentRenewal",
            name: "EquipmentRenewal",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/BackgroundSettings/EquipmentRenewal/EquipmentRenewal.vue",
              ], resolve),
            meta: {
              title: "EquipmentRenewal",
              keepAlive: true
            },
          },
        ],
      },
      {
        path: "/GovernmentRegulation",
        name: "GovernmentRegulation",
        redirect: "/GovernmentRegulation/AnnualReview",
        icon: "zhengfu",
        navShow: false,
        component: (resolve) => require(["../layout/transfer.vue"], resolve),
        meta: {
          title: "GovernmentRegulation"
        },
        children: [
          {
            path: "/GovernmentRegulation/AnnualReview",
            name: "AnnualReview",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/GovernmentRegulation/AnnualReview/AnnualReview.vue",
              ], resolve),
            meta: {
              title: "AnnualReview",
              keepAlive: true
            },
          },
          {
            path: "/GovernmentRegulation/JurisdictionalCompanies",
            name: "JurisdictionalCompanies",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/GovernmentRegulation/JurisdictionalCompanies/JurisdictionalCompanies.vue",
              ], resolve),
            meta: {
              title: "JurisdictionalCompanies",
              keepAlive: true
            },
          },
          {
            path: "/GovernmentRegulation/JurisdictionalCar",
            name: "JurisdictionalCar",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/GovernmentRegulation/JurisdictionalCar/JurisdictionalCar.vue",
              ], resolve),
            meta: {
              title: "JurisdictionalCar",
              keepAlive: true
            },
          },
          {
            path: "/GovernmentRegulation/JurisdictionalDriver",
            name: "JurisdictionalDriver",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/GovernmentRegulation/JurisdictionalDriver/JurisdictionalDriver.vue",
              ], resolve),
            meta: {
              title: "JurisdictionalDriver",
              keepAlive: true
            },
          },
          {
            path: "/GovernmentRegulation/JurisdictionalAnalysis",
            name: "JurisdictionalAnalysis",
            navShow: false,
            component: (resolve) =>
              require([
                "../layout/transfer.vue",
              ], resolve),
            meta: {
              title: "JurisdictionalAnalysis"
            },
            children: [
              {
                path: '/GovernmentRegulation/JurisdictionalAnalysis/Comprehensive',
                name: 'Comprehensive',
                navShow: false,
                component: resolve => require(['../views/GovernmentRegulation/JurisdictionalAnalysis/Comprehensive/Comprehensive.vue'], resolve),
                meta: {
                  title: "Comprehensive",
                  keepAlive: true
                },
              },
              {
                path: '/GovernmentRegulation/JurisdictionalAnalysis/Secure',
                name: 'Secure',
                navShow: false,
                component: resolve => require(['../views/GovernmentRegulation/JurisdictionalAnalysis/Secure/Secure.vue'], resolve),
                meta: {
                  title: "Secure",
                  keepAlive: true
                },
              },
            ]
          },
          {
            path: "/GovernmentRegulation/EnforcementNotes",
            name: "EnforcementNotes",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/GovernmentRegulation/EnforcementNotes/EnforcementNotes.vue",
              ], resolve),
            meta: {
              title: "EnforcementNotes",
              keepAlive: true
            },
          },
          {
            path: "/GovernmentRegulation/PolicyRule",
            name: "PolicyRule",
            navShow: false,
            component: (resolve) =>
              require([
                "../views/GovernmentRegulation/PolicyRule/PolicyRule.vue",
              ], resolve),
            meta: {
              title: "PolicyRule",
              keepAlive: true
            },
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    zhName: "登录页",
    component: (resolve) => require(["../views/Login.vue"], resolve),
  },
  {
    path: "/HomePage",
    name: "HomePage",
    icon: "homeicon",
    navShow: false,
    component: (resolve) => require(['../views/HomePage' + sessionStorage.getItem('path') + '.vue'], resolve),
    meta: {
      title: "home"
    },
  },
  {
    path: "/PrivacyAgreement",
    name: "PrivacyAgreement",
    icon: "homeicon",
    component: (resolve) => require(["../views/PrivacyAgreement.vue"], resolve),
  },
  ,
  {
    path: "/404",
    name: "404",
    icon: "homeicon",
    component: (resolve) => require(["../views/404.vue"], resolve),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {

  //例外列表，不需要token
  if (to.path == '/login' || to.path == '/404' || to.path == '/PrivacyAgreement') {
    next()
  }
  // 需要验证
  else {
    let token = sessionStorage.getItem('token')
    let menu = JSON.parse(sessionStorage.getItem('menu'));
    if (!token && to.path !== '/login') {
      console.log('token', token)
      next('/login')
    }
    else {
      next()
    }
  }
})

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

export default router;